import LinkCustom from "./link-custom";

export default LinkCustom;
